/** Perfil de especificación: targets normalizados por la media de los SKU comparados.
 *  Es la única forma que muestra "la forma del producto" de un vistazo; la tabla de la tarjeta
 *  lleva los valores exactos, que es lo que se cita. */
import type { Grafico, Idioma, Serie as SerieT } from "../lib/tipos";
import { Leyenda, Marco, colorSerie, useEsMovil } from "./comun";

const LADO = 320;
const R = 108;

export function GraficoRadar({ grafico, idioma }: { grafico: Grafico; idioma: Idioma }) {
  const series = (grafico.series ?? []) as SerieT[];
  const movil = useEsMovil();
  const ejes = series[0]?.puntos.map((p) => String(p.x)) ?? [];
  if (!series.length || ejes.length < 3) return null;
  const centro = LADO / 2;
  const angulo = (i: number) => (i / ejes.length) * 2 * Math.PI - Math.PI / 2;
  const punto = (i: number, v: number) => [centro + Math.cos(angulo(i)) * R * v, centro + Math.sin(angulo(i)) * R * v] as const;

  return (
    <>
      <Marco titulo={grafico.titulo} idioma={idioma} ancho={LADO} alto={LADO}>
        <svg viewBox={`0 0 ${LADO} ${LADO}`} width="100%" height="100%">
          {[0.5, 0.75, 1, 1.25].map((anillo) => (
            <polygon key={anillo} points={ejes.map((_, i) => punto(i, anillo / 1.25).join(",")).join(" ")}
                     fill="none" stroke="var(--borde)" strokeWidth="1" />
          ))}
          {ejes.map((e, i) => {
            const [x, y] = punto(i, 1.32);
            return (
              <g key={e}>
                <line x1={centro} y1={centro} x2={punto(i, 1)[0]} y2={punto(i, 1)[1]} stroke="var(--borde)" strokeWidth="1" />
                <text x={x} y={y} fontSize={movil ? 11 : 8} fill="var(--texto-3)" textAnchor={x > centro + 5 ? "start" : x < centro - 5 ? "end" : "middle"}
                      dominantBaseline="middle">
                  {e.length > 11 ? `${e.slice(0, 10)}…` : e}
                </text>
              </g>
            );
          })}
          {series.map((s, si) => {
            const validos = s.puntos.map((p, i) => (p.y === null ? null : punto(i, Math.min(p.y, 1.25) / 1.25))).filter(Boolean) as (readonly [number, number])[];
            if (validos.length < 3) return null;
            return (
              <polygon key={s.nombre} points={validos.map((p) => p.join(",")).join(" ")}
                       fill={colorSerie(si)} fillOpacity="0.1" stroke={colorSerie(si)} strokeWidth="2" strokeLinejoin="round" />
            );
          })}
        </svg>
      </Marco>
      <Leyenda items={series.map((s, i) => ({ nombre: s.nombre, color: colorSerie(i) }))} />
    </>
  );
}
